import React from "react";
import "../Styles/Process.css";

const Process = ({ scrollToSection }) => {
  return (
    <section className="our-process">
      <div className="container">
        <div className="process-head reveal">
          <p className="eyebrow">Getting started</p>
          <h2 className="section-title process-title">A simple path from first call to better grades</h2>
          <p className="section-lead">
            No pressure, no long contracts to start. Just a clear process built around your student’s needs.
          </p>
        </div>

        <div className="process-container stagger">
          <article className="process-step reveal">
            <div className="process-content">
              <h3>Free intro call</h3>
              <p>
                We learn your goals, subject needs, schedule, and what has (or hasn’t) worked so far.
              </p>
            </div>
          </article>

          <article className="process-step reveal">
            <div className="process-content">
              <h3>Tutor match</h3>
              <p>
                We pair your student with a tutor who fits academically and personally for a strong first session.
              </p>
            </div>
          </article>

          <article className="process-step reveal">
            <div className="process-content">
              <h3>Focused sessions</h3>
              <p>
                Sessions build understanding, confidence, and better study habits — not just completed homework.
              </p>
            </div>
          </article>

          <article className="process-step reveal">
            <div className="process-content">
              <h3>Ongoing check-ins</h3>
              <p>
                We follow up so progress stays visible and we can adjust support as needs change.
              </p>
            </div>
          </article>
        </div>

        <div className="process-cta reveal">
          <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
            Start With a Free Intro Call
          </button>
        </div>
      </div>
    </section>
  );
};

export default Process;
